export const formatCommentDate = (value) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";

  return parsed.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).replace(/\s+/g, " ").toLowerCase();
};

export const normalizeComments = (value) => {
  if (!value) return [];

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return normalizeComments(parsed);
    } catch (error) {
      return [];
    }
  }

  if (!Array.isArray(value)) return [];

  return value
    .filter(Boolean)
    .map((item) => ({
      text: typeof item?.text === "string" ? item.text.trim() : "",
      created_at: item?.created_at || new Date().toISOString(),
    }))
    .filter((item) => item.text);
};

export const buildCommentEntry = (text) => ({
  text: text?.trim() || "",
  created_at: new Date().toISOString(),
});
